<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tabla Dinámica Camiones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">Administración</li>
                  <li class="breadcrumb-item active">Flota</li>
                  <li class="breadcrumb-item active">Camiones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <div class="card">
          <div class="card-header pt-2 pb-2">
            <div class="row">
              <div class="col-md-6">
                <h5>Filtros</h5>
              </div>
            </div>
          </div>
          <div class="card-body">
            <!-- Acordeón de filtros -->
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Seleccionar Tipo Busqueda</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="tipo_consulta"
                    :class="
                      $v.tipo_consulta.$invalid ? 'is-invalid' : 'is-valid'
                    "
                  >
                    <option :value="1">Camiones</option>
                    <option :value="2">Documentos</option>
                  </select>
                </div>
              </div>
              <div class="form-group col-md-2">
                <label>Placa</label>
                <input
                  type="text"
                  id="placa"
                  placeholder="Placa"
                  label="Placa"
                  v-model="filtros.placa"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group col-md-3">
                <label>Tipo de Camión</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_vehiculo_id"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_vehiculo in listasForms.tipos_vehiculos"
                    :key="tipo_vehiculo.id"
                    :value="tipo_vehiculo.id"
                  >
                    {{ tipo_vehiculo.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Empresa</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.empresa_id"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="empresa in listasForms.empresas"
                    :key="empresa.id"
                    :value="empresa.id"
                  >
                    {{ empresa.razon_social }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Tipo de Carrocería</label>

                <select
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_carroceria"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_carroceria in listasForms.tipos_carrocerias"
                    :key="tipo_carroceria.numeracion"
                    :value="tipo_carroceria.numeracion"
                  >
                    {{ tipo_carroceria.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Numero de Motor</label>
                <input
                  type="text"
                  id="numero_motor"
                  placeholder="Numero de Motor"
                  v-model="filtros.numero_motor"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group col-md-2">
                <label>Modelo</label>
                <input
                  type="number"
                  id="Modelos"
                  placeholder="Modelo"
                  v-model="filtros.modelo"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group col-md-2">
                <label>Numero de Chasis</label>
                <input
                  type="number"
                  id="numero_chasis"
                  placeholder="Numero Chasis"
                  v-model="filtros.numero_chasis"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group col-md-2">
                <label>Color</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.color"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="color in listasForms.colores"
                    :key="color.numeracion"
                    :value="color.numeracion"
                  >
                    {{ color.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Marca</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.marca"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="marca in listasForms.marcas"
                    :key="marca.numeracion"
                    :value="marca.numeracion"
                  >
                    {{ marca.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Tipo de Capacidad</label>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_capacidad"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_capacidad in listasForms.tipos_capacidad"
                    :key="tipo_capacidad.numeracion"
                    :value="tipo_capacidad.numeracion"
                  >
                    {{ tipo_capacidad.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Estado</label>
                <select
                  id="estado"
                  class="form-control form-control-sm"
                  v-model="filtros.estado"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="estado in listasForms.estados"
                    :key="estado.numeracion"
                    :value="estado.numeracion"
                  >
                    {{ estado.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Propiedad</label>
                <select
                  id="tipo_propiedad"
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_propiedad"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_propiedad in listasForms.tipos_propiedad"
                    :key="tipo_propiedad.numeracion"
                    :value="tipo_propiedad.numeracion"
                  >
                    {{ tipo_propiedad.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label>Tipo de Combustible</label>
                <select
                  id="tipo_combustible"
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_combustible"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_combustible in listasForms.tipos_combustible"
                    :key="tipo_combustible.numeracion"
                    :value="tipo_combustible.numeracion"
                  >
                    {{ tipo_combustible.descripcion }}
                  </option>
                </select>
              </div>
              <div class="col-md-2 mt-3 pt-3">
                <button
                  type="button"
                  v-show="!$v.tipo_consulta.$invalid"
                  class="btn bg-navy btn-sm"
                  @click="generarPivotTable()"
                  v-if="$store.getters.can('argentina.camiones.pivotTable')"
                >
                  Generar Busqueda
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <pivot-table-component
                      v-if="pivotData"
                      :pivotData="pivotData"
                      :aggregator-name="aggregatorName"
                      :renderer-name="rendererName"
                    >
                    </pivot-table-component>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="row">
                <button class="btn bg-secondary col-md-1" @click="back()">
                  <i class="fas fa-reply"></i>
                  <br />Volver
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PivotTableComponent from "../../../../components/PivotTableComponent.vue";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
export default {
  name: "CamionesPivotTable",
  components: {
    PivotTableComponent,
    Loading,
  },
  data() {
    return {
      cargando: false,
      dataPivot: [],
      pivotData: [],
      aggregatorName: "Sum",
      rendererName: "Table Heatmap",
      filtros: {
        placa: null,
        tipo_vehiculo_id: null,
        empresa_id: null,
        tipo_carroceria: null,
        numero_motor: null,
        modelo: null,
        numero_chasis: null,
        color: null,
        marca: null,
        tipo_capacidad: null,
        estado: null,
        tipo_propiedad: null,
        tipo_combustible: null,
      },
      tipo_consulta: null,
      listasForms: {
        tipos_vehiculos: [],
        empresas: [],
        tipos_carrocerias: [],
        colores: [],
        marcas: [],
        tipos_capacidad: [],
        estados: [],
        tipos_propiedad: [],
        tipos_combustible: [],
      },
    };
  },
  validations: {
    tipo_consulta: {
      required,
    },
  },
  methods: {
    back() {
      return this.$router.replace("/Argentina/Flota/Camiones");
    },
    /*     async getTiposVehiculos() {
      // OBLIGATORIO: Filtrar solo tipos de vehículos con linea_negocio_id = 15
      await axios.get("/api/admin/tiposVehiculos/lista", {
        params: {
          linea_negocio_id: [15]
        }
      }).then((response) => {
        this.listasForms.tipos_vehiculos = response.data;
      });
    },
 */

    getTiposVehiculos(tipo_vehiculos) {
      let me = this;
      var url = "/api/admin/tiposVehiculos/lista";
      axios
        .get(url, {
          params: {
            linea_negocio_id: [15], // OBLIGATORIO: Solo línea de negocio 15 para Argentina
            not_id: tipo_vehiculos,
          },
        })
        .then(function (response) {
          let respuesta = response.data;
          me.listasForms.tipos_vehiculos = respuesta;
        })
        .catch(function (error) {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getEmpresas() {
      // OBLIGATORIO: Cargar solo empresas con pais_id = 3
      await axios
        .get("/api/argentina/empresas/lista", {
          params: {
            pais_id: 3,
          },
        })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },

    async getTipoCarroceria() {
      await axios.get("/api/lista/9").then((response) => {
        this.listasForms.tipos_carrocerias = response.data;
      });
    },

    async getColores() {
      await axios.get("/api/lista/11").then((response) => {
        this.listasForms.colores = response.data;
      });
    },

    async getMarcas() {
      await axios.get("/api/lista/12").then((response) => {
        this.listasForms.marcas = response.data;
      });
    },

    async getTiposCapacidad() {
      await axios.get("/api/lista/13").then((response) => {
        this.listasForms.tipos_capacidad = response.data;
      });
    },

    getEstado() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    async getTiposPropiedad() {
      await axios.get("/api/lista/23").then((response) => {
        this.listasForms.tipos_propiedad = response.data;
      });
    },

    async getCombustibles() {
      await axios.get("/api/lista/24").then((response) => {
        this.listasForms.tipos_combustible = response.data;
      });
    },

    generarPivotTable() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/camiones/pivotTable",
        data: { tipo_consulta: this.tipo_consulta, filtros: this.filtros },
      })
        .then((response) => {
          this.cargando = false;
          this.pivotData = response.data;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
  async mounted() {
    this.cargando = true;
    await this.getTiposVehiculos();
    await this.getEmpresas();
    await this.getTipoCarroceria();
    await this.getColores();
    await this.getMarcas();
    await this.getTiposCapacidad();
    await this.getEstado();
    await this.getTiposPropiedad();
    await this.getCombustibles();
    this.cargando = false;
  },
};
</script>
